/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionDTO
 */
export interface SessionDTO {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof SessionDTO
     */
    comment?: string | null;
}

/**
 * Check if a given object implements the SessionDTO interface.
 */
export function instanceOfSessionDTO(value: object): value is SessionDTO {
    return true;
}

export function SessionDTOFromJSON(json: any): SessionDTO {
    return SessionDTOFromJSONTyped(json, false);
}

export function SessionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionDTO {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function SessionDTOToJSON(json: any): SessionDTO {
    return SessionDTOToJSONTyped(json, false);
}

export function SessionDTOToJSONTyped(value?: SessionDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'comment': value['comment'],
    };
}

